module.exports = __webpack_public_path__ + "static/saas-banner2-0b2678017ccf482bafef3c6e070b818e.png";